// extracted by mini-css-extract-plugin
export default {"verifyEmail":"styles_verifyEmail__57hU0","header":"styles_header__yZ3KN","logo":"styles_logo__XCQKF","pendingWrapper":"styles_pendingWrapper__eJkXl"};